// Pages that live outside the chat: a shared chat's public snapshot (/s/:token, no sign-in)
// and accepting an invitation to a workspace (/invite/:token, after sign-in).

import { h, Component } from 'preact';
import { route } from 'preact-router';
import { publicSnapshot, acceptInvite, getMe, logout } from '../api.js';
import { Feed } from './feed.js';
import { Orb } from './orb.js';
import './ui.css';

// ─── /s/:token ────────────────────────────────────────────────────────────────
export class SharedChat extends Component {
  constructor(p) { super(p); this.state = { snap: null, error: '' }; }
  async componentDidMount() {
    try {
      const snap = await publicSnapshot(this.props.token);
      this.setState({ snap });
      document.title = `${snap.title} — shared on eutonomous AI workspaces`;
    } catch (e) { this.setState({ error: e.message }); }
  }
  render({ token }, { snap, error }) {
    const fileUrl = (path) => `/api/s/${encodeURIComponent(token)}/file?path=${encodeURIComponent(path)}`;
    const items = snap ? snap.messages.map((m, i) => ({
      key: 's' + i, role: m.role, content: m.content || '', run: m.run,
      attachments: m.attachments, author: m.role === 'user' ? 'shared' : null, author_name: m.author_name,
      kind: m.kind, settled: m.label, status: m.status || 'completed', tool_name: m.label,
    })) : [];
    return h('div', { className: 'public-page' },
      h('header', { className: 'public-head' },
        h('a', { className: 'brand-pub', href: '/' }, h(Orb, { state: 'idle', size: 20 }), h('b', null, 'eutonomous')),
        snap ? h('div', { className: 'grow pub-title' }, h('h1', null, snap.title),
          h('small', null, `Shared by ${snap.owner_name || 'someone'} · ${new Date((snap.shared_at || '') + 'Z').toLocaleDateString()} · read-only snapshot`)) : h('div', { className: 'grow' }),
        h('a', { className: 'btn primary', href: '/' }, 'Start your own workspace')),
      error ? h('div', { className: 'public-empty' }, h(Orb, { state: 'asleep', size: 48 }), h('h2', null, 'This link doesn’t work any more'),
        h('p', { className: 'muted' }, 'It may have been revoked by the person who shared it.'))
        : !snap ? h('div', { className: 'feed-wrap' }, h('div', { className: 'feed' }, h('div', { className: 'feed-inner' }, h('div', { className: 'skel' }, h('span', null), h('span', null), h('span', { className: 'short' })))))
        : h(Feed, { items, pid: null, busy: false, fileUrl, me: null, canChat: false, onAnswer: null, onOpenFile: null, onRetry: null,
          empty: h('p', { className: 'muted' }, 'This chat is empty.') }));
  }
}

// ─── /invite/:token ───────────────────────────────────────────────────────────
export class AcceptInvite extends Component {
  constructor(p) { super(p); this.state = { phase: 'working', error: '', email: '' }; }
  async componentDidMount() {
    const me = await getMe();
    if (!me.signed_in) {
      window.location.href = '/api/auth/login?next=' + encodeURIComponent(location.pathname);
      return;
    }
    this.setState({ email: me.account.email });
    try {
      const r = await acceptInvite(this.props.token);
      const ws = (r.workspaces || [])[0];
      try { if (ws) localStorage.setItem('uai.workspace', String(ws)); } catch (e) { /* */ }
      this.setState({ phase: 'done' });
      setTimeout(() => route(ws ? '/?workspace=' + ws : '/'), 900);
    } catch (e) { this.setState({ phase: 'error', error: e.message }); }
  }
  render(_, { phase, error, email }) {
    return h('div', { className: 'public-empty' },
      h(Orb, { state: phase === 'error' ? 'error' : phase === 'done' ? 'idle' : 'waking', size: 56 }),
      phase === 'working' ? h('h2', null, 'Joining the workspace…')
        : phase === 'done' ? h('h2', null, 'You’re in. Opening it…')
        : h('div', null, h('h2', null, 'This invitation can’t be used'), h('p', { className: 'muted' }, error),
          email ? h('p', { className: 'muted' }, `You are signed in as ${email}. `,
            h('button', { type: 'button', className: 'btn ghost', onClick: () => logout() }, 'Sign in with another address')) : null,
          h('a', { className: 'btn primary', href: '/' }, 'Go to your workspaces')));
  }
}
